// tslint:disable
/**
 * Import Export Api Manager (V2)
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Info } from './info';

/**
 * 
 * @export
 * @interface Export
 */
export interface Export {
    /**
     * 
     * @type {string}
     * @memberof Export
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Export
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof Export
     */
    type: string;
    /**
     * 
     * @type {Info}
     * @memberof Export
     */
    typeInfo: Info;
    /**
     * 
     * @type {string}
     * @memberof Export
     */
    status: ExportStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof Export
     */
    startedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Export
     */
    finishedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Export
     */
    createdAt: Date;
}

/**
    * @export
    * @enum {string}
    */
export enum ExportStatusEnum {
    Waiting = 'waiting',
    Started = 'started',
    Success = 'success',
    Fail = 'fail'
}



